// import Image from "next/image";
import DashboardIcon from "../public/sidebar/dashboard-icon.svg";
import CustomersIcon from "../public/sidebar/customers-icon.svg";
import ServiceProviders from "../public/sidebar/service-providers.svg";
import ServicesIcon from "../public/sidebar/services-icon.svg";
import NotificationIcon from "../public/sidebar/notifications_active.svg";
import SettingsIcon from "../public/sidebar/settings.svg";
import ChatIcon from "../public/sidebar/chat-icon.svg";
import VerificationIcon from "../public/sidebar/verification-icon.svg";
import PromoCodeIcon from "../public/sidebar/promo-code-icon.svg";
import ActivePromoCodeIcon from "../public/sidebar/active-promo-code-icon.svg";

// Acitve Icons
import DashboardActiveIcon from "../public/sidebar/active-dashboard-icon.svg";
import CustomersActiveIcon from "../public/sidebar/active-customers-icon.svg";
import sPActiveIcon from "../public/sidebar/active-service-providers.svg";
import ServicesActiveIcon from "../public/sidebar/active-customers-icon.svg";
import NotificationActiveIcon from "../public/sidebar/active-notification-icon.svg";
import SettingsActiveIcon from "../public/sidebar/active-settings-icon.svg";
import ChatActiveIcon from "../public/sidebar/active-chat-icon.svg";
import VerificationActiveIcon from "../public/sidebar/active-verification-icon.svg";
import AgentsIcon from "../public/sidebar/agents-icon.svg";
import AgentsActiveIcon from "../public/sidebar/active-agents-icon.svg";
import ReferralIcon from "../public/sidebar/referrals.svg";
import LessThanTwoStarsIcon from "../public/sidebar/less-than-two-stars.svg";
import ReferralActiveIcon from "../public/sidebar/active-referrals.svg";
import LessThanTwoStarsActiveIcon from "../public/sidebar/active-less-than-two-stars.svg";

// Money nav items ("All Transactions", "Withdrawals") were removed: Pureworker
// does not hold funds, and their backend routes are gone. They had no frontend
// route either, so clicking them landed on "Route not found".
const items = [
  {icon: CustomersIcon, activeIcon: CustomersActiveIcon, label: "Pureworker Pro", key: "pureworker-pro", isActive: false},
  {icon: NotificationIcon, activeIcon: NotificationActiveIcon, label: "Artisan Nominations", key: "artisan-nominations", isActive: false},
  {icon: NotificationIcon, activeIcon: NotificationActiveIcon, label: "Ad Campaigns", key: "ad-campaigns", isActive: false},
  {icon: NotificationIcon, activeIcon: NotificationActiveIcon, label: "Bulk SMS", key: "bulk-sms", isActive: false},
  {icon: AgentsIcon, activeIcon: AgentsActiveIcon, label: "Field work", key: "field-work", isActive: false},
  {icon: AgentsIcon, activeIcon: AgentsActiveIcon, label: "Telemarketing", key: "telemarketing", isActive: false},
  {icon: VerificationIcon, activeIcon: VerificationActiveIcon, label: 'Verified SPs', key: 'verified-providers', isActive: false},
  {icon: VerificationIcon, activeIcon: VerificationActiveIcon, label: 'Unverified SPs', key: 'unverified-providers', isActive: false},
  {icon: CustomersIcon, activeIcon: CustomersActiveIcon, label: "Registrations", key: "registrations", isActive: false},
  {
    icon: DashboardIcon,
    activeIcon: DashboardActiveIcon,
    label: "Dashboard",
    key: "dashboard",
    isActive: false,
  },
  {
    icon: CustomersIcon,
    activeIcon: CustomersActiveIcon,
    label: "Customers",
    key: "customers",
    isActive: false,
  },
  {
    icon: ServiceProviders,
    activeIcon: sPActiveIcon,
    label: "Service Providers",
    key: "serviceProviders",
    isActive: false,
  },
  {
    icon: ServicesIcon,
    activeIcon: ServicesActiveIcon,
    label: "Services",
    key: "services",
    isActive: false,
  },
  {
    icon: PromoCodeIcon,
    activeIcon: ActivePromoCodeIcon,
    label: "Promo Code",
    key: "promoCode",
    isActive: false,
  },
  {
    icon: NotificationIcon,
    activeIcon: NotificationActiveIcon,
    label: "Notification",
    key: "notification",
    isActive: false,
  },
  {
    icon: NotificationIcon,
    activeIcon: NotificationActiveIcon,
    label: "Outreach",
    key: "outreach",
    isActive: false,
  },
  {
    icon: NotificationIcon,
    activeIcon: NotificationActiveIcon,
    label: "Emails",
    key: "emails",
    isActive: false,
  },
  {
    icon: NotificationIcon,
    activeIcon: NotificationActiveIcon,
    label: "Blog",
    key: "blog",
    isActive: false,
  },
  {
    icon: ReferralIcon,
    activeIcon: ReferralActiveIcon,
    label: "Referrals",
    key: "referrals",
    isActive: false,
  },
  { icon: LessThanTwoStarsIcon, activeIcon: LessThanTwoStarsActiveIcon, label: "Ratings & Reviews", key: "ratings-reviews", isActive: false },
  { icon: ServiceProviders, activeIcon: sPActiveIcon, label: "Provider Performance", key: "provider-performance", isActive: false },
  { icon: DashboardIcon, activeIcon: DashboardActiveIcon, label: "Job Demand", key: "job-demand", isActive: false },
  { icon: ServiceProviders, activeIcon: sPActiveIcon, label: "Provider Ranking", key: "provider-ranking", isActive: false },
  { icon: ServiceProviders, activeIcon: sPActiveIcon, label: "Provider Recommendations", key: "provider-recommendations", isActive: false },
  {
    icon: LessThanTwoStarsIcon,
    activeIcon: LessThanTwoStarsActiveIcon,
    label: "< 2 Stars",
    key: "lessthantwostars",
    isActive: false,
  },
  {
    icon: SettingsIcon,
    activeIcon: SettingsActiveIcon,
    label: "Settings",
    key: "settings",
    isActive: false,
  },
  {
    icon: ChatIcon,
    activeIcon: ChatActiveIcon,
    label: "Support Chats",
    key: "chat",
    isActive: false,
  },
  {
    icon: VerificationIcon,
    activeIcon: VerificationActiveIcon,
    label: "Verification",
    key: "verification",
    isActive: false,
  },
  {
    icon: VerificationIcon,
    activeIcon: VerificationActiveIcon,
    label: "ID Check",
    key: "id-check",
    isActive: false,
  },
  {
    icon: AgentsIcon,
    activeIcon: AgentsActiveIcon,
    label: "Add Agents",
    key: "agents",
    isActive: false,
  },
  {icon: ChatIcon, activeIcon: ChatActiveIcon, label: "App Chats", key: "app-chats", isActive: false},
  // Agent admin (consolidated). Reuse existing icons to avoid new assets; each
  // key must match the route path segment in sidebar2.tsx.
  {
    icon: ChatIcon,
    activeIcon: ChatActiveIcon,
    label: "Conversations",
    key: "conversations",
    isActive: false,
  },
  {
    icon: CustomersIcon,
    activeIcon: CustomersActiveIcon,
    label: "Requests",
    key: "requests",
    isActive: false,
  },
  {
    icon: ServiceProviders,
    activeIcon: sPActiveIcon,
    label: "Dispatch Jobs",
    key: "dispatch-jobs",
    isActive: false,
  },
  {
    icon: VerificationIcon,
    activeIcon: VerificationActiveIcon,
    label: "Review Queue",
    key: "flag-review",
    isActive: false,
  },
  {
    icon: NotificationIcon,
    activeIcon: NotificationActiveIcon,
    label: "Failed Messages",
    key: "dead-letters",
    isActive: false,
  },
  {
    icon: DashboardIcon,
    activeIcon: DashboardActiveIcon,
    label: "Costs",
    key: "costs",
    isActive: false,
  },
  {
    icon: DashboardIcon,
    activeIcon: DashboardActiveIcon,
    label: "Agent Metrics",
    key: "agent-metrics",
    isActive: false,
  },
  {
    icon: ServiceProviders,
    activeIcon: sPActiveIcon,
    label: "Blocklist",
    key: "blocklist",
    isActive: false,
  },
  {
    icon: CustomersIcon,
    activeIcon: CustomersActiveIcon,
    label: "Intros",
    key: "intros",
    isActive: false,
  },
  {
    icon: CustomersIcon,
    activeIcon: CustomersActiveIcon,
    label: "Unmet Demand",
    key: "waitlist",
    isActive: false,
  },
  {
    icon: CustomersIcon,
    activeIcon: CustomersActiveIcon,
    label: "Suspensions",
    key: "suspensions",
    isActive: false,
  },
  {
    icon: ServicesIcon,
    activeIcon: ServicesActiveIcon,
    label: "Dev Data",
    key: "dev-data",
    isActive: false,
  },
  {
    icon: VerificationIcon,
    activeIcon: VerificationActiveIcon,
    label: "Audit Log",
    key: "audit-log",
    isActive: false,
  },
];

// One navigation model for desktop and mobile. Less frequent tools remain available.
export const navigationGroups = [
  { label: "Daily work", keys: ["dashboard", "registrations", "conversations", "chat", "app-chats", "requests", "job-demand", "outreach", "flag-review", "dead-letters", "dispatch-jobs"] },
  { label: "People & services", keys: ["serviceProviders", "customers", "verification", "id-check", "verified-providers", "unverified-providers", "services", "provider-recommendations", "provider-ranking", "provider-performance", "ratings-reviews", "waitlist"] },
  { label: "Operations", keys: ["pureworker-pro", "artisan-nominations", "ad-campaigns", "costs", "bulk-sms", "agent-metrics", "suspensions", "blocklist", "audit-log", "field-work", "telemarketing", "settings", "agents"] },
  { label: "More tools", keys: ["notification", "emails", "blog", "referrals", "promoCode", "lessthantwostars", "intros", "dev-data"] },
];
const SidebarItems = navigationGroups.flatMap(group => group.keys.map(key => items.find(item => item.key === key)!));
export const visibleSidebarItems = (accountType?: string, telemarketingEnabled = false) => SidebarItems.filter(item =>
  accountType === 'telemarketer' ? item.key === 'telemarketing' : accountType === 'marketer' ? item.key === 'field-work' || (telemarketingEnabled && item.key === 'telemarketing') : item.key !== "agents" || accountType?.toLowerCase() === "super_admin");
export function activeNavigationKey(pathname: string) {
  // Older ID-detail bookmarks used the profile-verification URL prefix.
  if (/^\/verification\/[^/]+\/verify-nin\/?$/.test(pathname)) return "id-check";
  const key = pathname.split("/")[1] || "dashboard";
  const aliases: Record<string, string> = {provider: "serviceProviders", "email-templates": "emails", "create-blog": "blog"};
  return aliases[key] || key;
}
export default SidebarItems;
